import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {RootState} from '../../reducer';
import {useNavigate} from 'react-router-dom';
import {PostInterface} from '../../interface/post.interface';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import './editor/PostEditor.css';
import ReplyList from './ReplyList';
import {MenuInterface} from "../../interface/menu.interface";
import VisibilityIcon from '@mui/icons-material/Visibility';
import EmotionBox from "./emotion/EmotionBox";
import {EmotionInterface} from "../../interface/emotion.interface";
import FileList from "./fileUpload/FileList";

interface SidePost {
    no: number,
    title: string
}

interface State {
    post: PostInterface,
    prevPost: SidePost,
    nextPost: SidePost,
    menu: MenuInterface,
    isEvaluator: boolean,
    emotionDetailList: EmotionInterface[]
}

export default function PostView() {

    const [state, setState] = useState<State>({
        post: {
            _id: '',
            contents: '',
            createdAt: null,
            id: '',
            no: 0,
            title: '',
            usage: '',
            workplace: '0',
            isBlockView: false,
            hitCount: 0,
            club: {_id: "", createdAt: new Date(), kind: "", name: "", usage: 'Y', workplace: ""},
            department: {
                _id: "",
                departmentCode: "",
                workplace: "",
                departmentName: ""
            },
            comment: {
                _id: "",
                content: "",
                createdAt: null,
                depth: 0,
                post: undefined,
                sorts: 0,
                targetWriter: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""},
                usage: "",
                user: {_id: "", admin: false, departmentCode: "", departmentName: "", id: "", name: ""}
            },
            user: {
                _id: '',
                admin: false,
                departmentCode: '',
                departmentName: '',
                id: '',
                name: '',
            },
            amount: 0,
            shareStatus: 0,
            thumbnail: "",
            replyCount: 0,
            isApprovedBestFriends: false,
            fmPurchasePrice: 0,
            fmBrand: "",
            fmCategory: "",
            fmModelNo: "",
            fmProductName: "",
            fmSellingPrice: 0,
            fmId: "",
            fleaMarket: {
                _id: "",
                createdAt: new Date(),
                end: new Date(),
                openYN: "",
                start: new Date(),
                title: "",
                usage: "",
                workplace: ""
            },
            fileNameList: [],
            fileUrlList: [],
            files: []
        },
        prevPost: {no: 0, title: ''},
        nextPost: {no: 0, title: ''},
        menu: {
            id: "", index: 0, name: "", path: "", subMenu: [], viewComment: false, placeholder: "",
            allowAdminReply: false, allowAdminPost: false
        },
        emotionDetailList: [],
        isEvaluator: false
    });

    const commonData = useSelector((state: RootState) => state.commonData);
    const navigate = useNavigate();

    let {id, workplace, no, page, club, department, keyword, searchType} = common.getQuery();

    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);
    useEffect(() => {
        getPost();
    }, [no]);


    function getPost() {
        axios.get(`${constance.api.getPostView}?id=${id}&no=${no}&workplace=${workplace}`).then(value => {
            if (!value.data.success) {
                navigate('/');
                return;
            }
            console.log(value);
            if (value.data.isBlockView) {
                common.alert('열람 제한', '게시물 열람이 제한되었습니다.', 'info');
                navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${1}&keyword=${keyword}&search-type=${searchType}`);
                return;
            } else {
                let post: PostInterface = value.data.post;
                let prev: SidePost = {no: 0, title: ''};
                let next: SidePost = {no: 0, title: ''};
                for (let data of value.data.sidePostList) {
                    if (data.no < post.no) {
                        prev = data;
                    } else if (data.no > post.no) {
                        next = data;
                    }
                }
                setState({
                    ...state,
                    post: value.data.post,
                    emotionDetailList: value.data.emotionDetailList,
                    prevPost: prev,
                    nextPost: next,
                    menu: menu,
                    isEvaluator: value.data.isEvaluator
                });
            }

        }).catch(reason => {
            console.log(reason);
        });
    }

    function moveSidePage(no: number) {
        navigate(`${config.url.postView}?id=${id}&workplace=${workplace}&no=${no}`);
    }

    function movePostList() {
        navigate(`${config.url.board}?id=${id}&workplace=${workplace}&page=${1}&keyword=${keyword}&search-type=${searchType}`);
    }

    function deletePost() {
        axios.post(constance.api.deletePost, {
            id: id,
            no: no,
        }).then(value => {
            console.log(value);
            common.alert('게시물 삭제 완료', '', 'info');
            movePostList();
        }).catch(reason => {
            console.log(reason);
        });
    }

    function updatePost() {
        navigate(`${config.url.postUpdate}?id=${id}&workplace=${workplace}&no=${no}`);
    }


    /* 베스트 프렌즈 승인하기 */
    function approveBestFriends() {
        axios.post(constance.api.approveBestFriends, {
            params: {_id: state.post._id},
        }).then(value => {
            console.log(value);
            common.alert('베스트 프렌즈 승인', value.data.result, 'info');
            movePostList();
        }).catch(reason => {
            console.log(reason);
            common.alert('베스트 프렌즈 승인', '승인 오류', 'info');
        });
    }

    if (common.isEmpty(state.post)) return <></>

    let title = '';
    if (state.post.club != null && state.post.club._id != '') {
        title = `[${constance.workplaceNameMap[state.post.club.workplace]} ${state.post.club.name}] ${state.post.title}`;
    } else if (state.post.department != null && state.post.department._id != '') {
        title = `[${constance.workplaceNameMap[state.post.department.workplace]} ${state.post.department.departmentName}] ${state.post.title}`
    } else if (id == 'fleaMarket') {
        title = `[${state.post.shareStatus == 0 ? '판매 중' : '판매 완료'}] ${state.post.title}`
    } else {
        title = `${state.post.workplace !== '0' ? `[${constance.workplaceNameMap[state.post.workplace]}]` : ''} ${state.post.title}`
    }

    const isAuthor = commonData.user.id == state.post.user.id;
    const hasPrev = state.prevPost.no != 0;
    const hasNext = state.nextPost.no != 0;

    return (
        <>
            <Box sx={{display: 'flex', justifyContent: 'center', p: {xs: 1, md: 2}}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    gap: 2,
                }}>
                    {/* 메인 카드 */}
                    <Paper
                        elevation={0}
                        sx={{
                            background: 'var(--scc-card-bg)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                            borderRadius: 2,
                            border: 1,
                            borderColor: 'divider',
                            overflow: 'hidden',
                        }}
                    >
                        {/* 헤더 영역 */}
                        <Box sx={{p: {xs: 2.5, md: 4}, pb: {xs: 2, md: 3}}}>
                            <Typography
                                variant={isMobile ? 'h6' : 'h4'}
                                sx={{fontWeight: 600, lineHeight: 1.35, wordBreak: 'keep-all'}}
                            >
                                {title}
                            </Typography>

                            <Box
                                sx={{
                                    mt: 2,
                                    color: 'text.secondary',
                                    display: 'flex',
                                    flexDirection: {xs: 'column', md: 'row'},
                                    alignItems: {xs: 'flex-start', md: 'center'},
                                    gap: {xs: 0.75, md: 1.5},
                                }}
                            >
                                <Stack direction="row" spacing={0.75} alignItems="center">
                                    <PersonOutlineIcon sx={{fontSize: 16}}/>
                                    <Typography variant="body2">
                                        {`${state.post.user.departmentName} ${state.post.user.name}`}
                                    </Typography>
                                </Stack>
                                <Box sx={{
                                    width: '1px', height: 12, bgcolor: 'divider',
                                    display: {xs: 'none', md: 'block'},
                                }}/>
                                <Stack direction="row" spacing={0.75} alignItems="center">
                                    <AccessTimeIcon sx={{fontSize: 16}}/>
                                    <Typography variant="body2">
                                        {common.getTimeFormat(state.post.createdAt)}
                                    </Typography>
                                </Stack>
                                <Box sx={{
                                    width: '1px', height: 12, bgcolor: 'divider',
                                    display: {xs: 'none', md: 'block'},
                                }}/>
                                <Stack direction="row" spacing={0.75} alignItems="center">
                                    <VisibilityIcon sx={{fontSize: 16}}/>
                                    <Typography variant="body2">{state.post.hitCount}</Typography>
                                </Stack>
                            </Box>
                        </Box>

                        <Divider/>

                        {/* 본문 영역 */}
                        <Box
                            sx={{
                                p: {xs: 2.5, md: 4},
                                minHeight: 320,
                                '.quill': {width: '100%'},
                                '.ql-editor': {padding: 0},
                                '.ql-editor p': {lineHeight: 2},
                                '.ql-video': {maxHeight: 800},
                            }}
                        >
                            {/* 공유 메타 */}
                            {id == 'share' && (
                                <Box
                                    sx={{
                                        background: 'var(--scc-card-meta-bg)',
                                        borderRadius: 1.5,
                                        p: 2,
                                        mb: 3,
                                    }}
                                >
                                    <MetaRow label="수량" value={String(state.post.amount)}/>
                                    <MetaRow label="나눔상태"
                                             value={state.post.shareStatus == 0 ? '진행 중' : '나눔 완료'}/>
                                </Box>
                            )}

                            {/* 플리마켓 메타 */}
                            {id == 'fleaMarket' && (
                                <Box
                                    sx={{
                                        background: 'var(--scc-card-meta-bg)',
                                        borderRadius: 1.5,
                                        p: 2,
                                        mb: 3,
                                    }}
                                >
                                    <MetaRow label="판매상태"
                                             value={state.post.shareStatus == 0 ? '판매 중' : '판매 완료'}/>
                                    <MetaRow label="제품명" value={state.post.fmProductName}/>
                                    <MetaRow label="수량" value={String(state.post.amount)}/>
                                    <MetaRow label="브랜드" value={state.post.fmBrand}/>
                                    <MetaRow label="모델번호" value={state.post.fmModelNo}/>
                                    <MetaRow label="구매가격"
                                             value={`${state.post.fmPurchasePrice ? state.post.fmPurchasePrice.toLocaleString() : 0}원`}/>
                                    <MetaRow label="시작가격"
                                             value={`${state.post.fmSellingPrice ? state.post.fmSellingPrice.toLocaleString() : 0}원`}/>
                                </Box>
                            )}

                            <ReactQuill
                                id={'quill-editor'}
                                value={state.post.contents}
                                readOnly={true}
                                style={{height: '100%'}}
                                theme={'bubble'}
                            />

                            {state.isEvaluator && (
                                <Box sx={{display: 'flex', justifyContent: 'center', mt: 3, mb: 1}}>
                                    <Button
                                        variant={'contained'}
                                        onClick={approveBestFriends}
                                        color={'info'}
                                        disabled={state.post.isApprovedBestFriends}
                                    >
                                        <Typography noWrap variant={'subtitle2'}>
                                            {state.post.isApprovedBestFriends ? '승인완료' : '승인하기'}
                                        </Typography>
                                    </Button>
                                </Box>
                            )}

                            <Box sx={{mt: 3}}>
                                <EmotionBox post={state.post} emotionDetailList={state.emotionDetailList}
                                            state={state} setState={setState}/>
                            </Box>

                            <Box sx={{mt: 2}}>
                                <FileList fileNameList={state.post.fileNameList}
                                          fileUrlList={state.post.fileUrlList}/>
                            </Box>
                        </Box>
                    </Paper>

                    {/* 이전/다음 게시물 네비 */}
                    {(hasPrev || hasNext) && (
                        <Stack direction="row" sx={{width: 1}}>
                            <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-start'}}>
                                {hasPrev && (
                                    <Box
                                        onClick={() => moveSidePage(state.prevPost.no)}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            color: 'text.secondary',
                                            transition: 'color 0.2s',
                                            '&:hover': {color: 'primary.main'},
                                            maxWidth: '100%',
                                            minWidth: 0,
                                        }}
                                    >
                                        <ArrowBackIosNewIcon sx={{fontSize: 14, mr: 0.5}}/>
                                        <Typography variant={isMobile ? 'caption' : 'body2'}
                                                    sx={{mr: 1, whiteSpace: 'nowrap'}}>
                                            이전글
                                        </Typography>
                                        <Typography
                                            variant={isMobile ? 'caption' : 'body2'}
                                            sx={{
                                                display: {xs: 'none', md: 'block'},
                                                ...styles.textHidden,
                                            }}
                                        >
                                            {state.prevPost.title}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                            <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                                {hasNext && (
                                    <Box
                                        onClick={() => moveSidePage(state.nextPost.no)}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            color: 'text.secondary',
                                            transition: 'color 0.2s',
                                            '&:hover': {color: 'primary.main'},
                                            maxWidth: '100%',
                                            minWidth: 0,
                                        }}
                                    >
                                        <Typography
                                            variant={isMobile ? 'caption' : 'body2'}
                                            sx={{
                                                display: {xs: 'none', md: 'block'},
                                                ...styles.textHidden,
                                            }}
                                        >
                                            {state.nextPost.title}
                                        </Typography>
                                        <Typography variant={isMobile ? 'caption' : 'body2'}
                                                    sx={{ml: 1, whiteSpace: 'nowrap'}}>
                                            다음글
                                        </Typography>
                                        <ArrowForwardIosIcon sx={{fontSize: 14, ml: 0.5}}/>
                                    </Box>
                                )}
                            </Box>
                        </Stack>
                    )}

                    {/* 액션 바 */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            rowGap: 1,
                        }}
                    >
                        <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-start'}}/>
                        <Box sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button onClick={movePostList}
                                    variant={'outlined'}
                                    color={'whiteOutlined'}
                                    size={isMobile ? 'small' : 'medium'}>
                                <Typography noWrap variant={isMobile ? 'subtitle2' : 'subtitle1'}>
                                    목록으로
                                </Typography>
                            </Button>
                        </Box>
                        <Box sx={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                        }}>
                            {isAuthor && (
                                <>
                                    <Button
                                        onClick={updatePost}
                                        variant={'contained'}
                                        color={'neutral'}
                                        size={isMobile ? 'small' : 'medium'}
                                    >
                                        <Typography noWrap variant={isMobile ? 'subtitle2' : 'subtitle1'}>
                                            수정하기
                                        </Typography>
                                    </Button>
                                    <Button
                                        onClick={deletePost}
                                        variant={'contained'}
                                        color={'error'}
                                        size={isMobile ? 'small' : 'medium'}
                                    >
                                        <Typography noWrap variant={isMobile ? 'subtitle2' : 'subtitle1'}>
                                            삭제하기
                                        </Typography>
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Box>

                    {/* 리플 박스 */}
                    <ReplyList post={state.post} menu={menu}/>
                </Stack>
            </Box>
        </>
    );
}

function MetaRow({label, value}: { label: string, value: string }) {
    return (
        <Stack direction="row" sx={{py: 0.5}}>
            <Typography variant="body2"
                        sx={{width: 100, color: 'text.secondary', flexShrink: 0}}>
                {label}
            </Typography>
            <Typography variant="body2" sx={{fontWeight: 500, wordBreak: 'keep-all'}}>
                {value}
            </Typography>
        </Stack>
    );
}

